import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { v4 as uuid } from "uuid";
import { object, string } from "yup";
import AutoCompleteSearch from "../../../components/dropdown/AutoCompleteSearch";
import DropdownCmp2 from "../../../components/dropdown/DropdownCmp2";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { GetEnumsResponse } from "../../../models/enum.model";
import {
  AddPermissionRequest,
  AddPermissionResponse,
  GetPermissionGroupsResponse,
  GetPermissionSubGroupsResponse,
} from "../../../models/permission.model";
import {
  AddPermission,
  EditPermission,
} from "../../../services/permission.service";

const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};
interface Props {
  setOpenAddSubReportModal: (state: boolean) => void;
  openAddSubReportModal: boolean;
  addOrEdit: "Add" | "Edit";
  setUpdateReports: (state: string) => void;
  permissionTypesOptions: GetEnumsResponse[];
  permissionGroupsOptions: GetPermissionGroupsResponse[];
  subPermission: GetPermissionSubGroupsResponse;
}

const editReportValidationSchema = object().shape({
  title: string()
    .ensure()
    .required("لطفا نام فارسی را وارد نمایید")
    .max(150, "نام فارسی نباید بیش از ۱۵۰ کاراکتر باشد"),
  name: string()
    .ensure()
    .required("لطفا نام انگلیسی را وارد نمایید")
    .max(150, "نام انگلیسی نباید بیش از ۱۵۰ کاراکتر باشد"),
});

const AddEditSubPermissionModal = ({
  setOpenAddSubReportModal,
  openAddSubReportModal,
  addOrEdit,
  setUpdateReports,
  permissionTypesOptions,
  permissionGroupsOptions,

  subPermission,
}: Props) => {
  const [permissionTypeValue, setPermissionTypeValue] = useState<any>();
  const [permissionGroupsValue, setPermissionGroupsValue] = useState<any>();
  const [permissionGroupResponse, setPermissionGroupResponse] = useState<any>();

  const initialValues: AddPermissionRequest = {
    title: addOrEdit === "Add" ? "" : subPermission?.title,
    name: addOrEdit === "Add" ? "" : subPermission?.name,
    permissionGroupId: 0,
    permissionType: "Unknown",
  };
  const { mutate: AddPermissionMutate } = useMutation(AddPermission, {
    onSuccess: (data: AddPermissionResponse) => {
      if (data) {
        setOpenAddSubReportModal(false);
        setUpdateReports(uuid());

        setPermissionGroupsValue(undefined);
        setPermissionTypeValue(undefined);
      }
    },
    onError: () => {},
  });
  const { mutate: EditPermissionMutate } = useMutation(EditPermission, {
    onSuccess: (data: boolean) => {
      if (data) {
        setOpenAddSubReportModal(false);
        setUpdateReports(uuid());
        setPermissionGroupsValue(undefined);
        setPermissionTypeValue(undefined);
      }
    },
    onError: () => {},
  });

  const handleSelectedTypeDrop = (e: any) => {
    setPermissionTypeValue(e.target.value);
  };
  const handleSelectedGroupsDrop = (e: any, value: any) => {
    setPermissionGroupsValue(e);
    setPermissionGroupResponse(value);
  };

  useEffect(() => {
    if (openAddSubReportModal) {
      if (addOrEdit === "Add") {
        setPermissionGroupsValue(undefined);
        setPermissionTypeValue(undefined);
      }
      if (addOrEdit === "Edit") {
        // setPermissionGroupsValue(subPermission?.permissionGroupId);
        setPermissionTypeValue(subPermission?.permissionTypeId);
      }
    }
  }, [openAddSubReportModal]);

  const handleSubmitSubReport = (values: AddPermissionRequest) => {
    if (addOrEdit === "Add") {
      AddPermissionMutate({
        name: values.name,
        title: values.title,
        permissionGroupId:
          permissionGroupsValue !== undefined
            ? permissionGroupsValue
            : subPermission?.permissionGroupId,
        permissionType: permissionTypeValue,
      });
    } else {
      EditPermissionMutate({
        name: values.name,
        title: values.title,
        id: subPermission.id,
        permissionGroupId:
          permissionGroupsValue !== undefined
            ? permissionGroupsValue
            : subPermission.permissionGroupId,
        permissionType:
          permissionTypeValue !== undefined
            ? permissionTypeValue
            : subPermission.permissionTypeId,
      });
    }
  };
  return (
    <>
      <div>
        <Modal
          open={openAddSubReportModal}
          onClose={() => {
            setOpenAddSubReportModal(false);

            setPermissionGroupsValue(undefined);
            setPermissionTypeValue(undefined);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={deactiveUserStyle}>
            <Typography
              component={"p"}
              display={"block"}
              textAlign={"center"}
              fontWeight={"bold"}
              //   marginY={"3rem"}
              fontSize={"14px"}
              color={"#1D4A87"}
            >
              {addOrEdit === "Add" ? (
                <span>افزودن دسترسی</span>
              ) : (
                <span>ویرایش دسترسی</span>
              )}{" "}
              ({subPermission?.applicationTitle})
            </Typography>
            <>
              <Formik
                initialValues={initialValues}
                onSubmit={handleSubmitSubReport}
                validateOnMount={true}
                validationSchema={editReportValidationSchema}
              >
                {({
                  handleSubmit,
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid
                      container
                      gap={"2rem"}
                      marginTop={"15px"}
                      maxWidth={"400px"}
                    >
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          placeHolder={"عنوان فارسی دسترسی"}
                          label={"عنوان فارسی دسترسی"}
                          required={true}
                          name={"title"}
                          id={"title"}
                          value={values.title}
                          helperText={touched.title ? errors.title : ""}
                          error={touched.title && Boolean(errors.title)}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          placeHolder={"عنوان انگلیسی دسترسی"}
                          label={"عنوان انگلیسی دسترسی"}
                          required={true}
                          name={"name"}
                          id={"name"}
                          value={values.name}
                          helperText={touched.name ? errors.name : ""}
                          error={touched.name && Boolean(errors.name)}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          onKeyDown={(e) => {
                            if (
                              /^[آ-ی ء چ]+$/.test(e.key) &&
                              e.code !== "Space"
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} className="permission-user-search">
                        <AutoCompleteSearch
                          label={"گروه دسترسی*"}
                          name="permissionGroups"
                          id="permissionGroups"
                          onChange={handleSelectedGroupsDrop}
                          value={permissionGroupsValue}
                          options={permissionGroupsOptions}
                          responseValue={permissionGroupResponse}
                          defaultValue={{
                            id:
                              addOrEdit === "Edit"
                                ? subPermission?.permissionGroupId
                                : undefined,
                            title:
                              addOrEdit === "Edit"
                                ? subPermission?.permissionGroupTitle
                                : undefined,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} className="dropdownCmp2-container">
                        <DropdownCmp2
                          style={{
                            paddingRight: "0 !important",
                            // maxWidth: "300px",
                          }}
                          onChange={handleSelectedTypeDrop}
                          value={permissionTypeValue}
                          label={"نوع دسترسی*"}
                          options={permissionTypesOptions}
                          name="permissionType"
                          id="permissionType"
                          darkTheme={true}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Grid
                          container
                          justifyContent={"center"}
                          alignItems={"center"}
                          gap={1}
                          marginBottom={"8px"}
                        >
                          <Grid item xs={5} width={"100%"}>
                            <Button
                              fullWidth
                              type="submit"
                              variant="contained"
                              sx={{ borderRadius: "5px !important" }}
                              disabled={
                                !values.title ||
                                !values.name ||
                                (values.title === subPermission?.title &&
                                  values.name === subPermission?.name &&
                                  permissionTypeValue ===
                                    subPermission?.permissionTypeId &&
                                  permissionGroupsValue ===
                                    subPermission?.permissionGroupId)
                              }
                              className={
                                !values.title ||
                                !values.name ||
                                (values.title === subPermission?.title &&
                                  values.name === subPermission?.name &&
                                  permissionTypeValue ===
                                    subPermission?.permissionTypeId &&
                                  permissionGroupsValue ===
                                    subPermission?.permissionGroupId)
                                  ? "btnForm disabledBtn"
                                  : "btnForm SuccessDefault"
                              }
                            >
                              ثبت
                            </Button>
                          </Grid>
                          <Grid item xs={5} width={"100%"}>
                            <Button
                              fullWidth
                              variant="contained"
                              style={{
                                fontSize: "1rem",
                                color: "#fff",
                                height: "40px",
                                background: "#607D8B",
                              }}
                              sx={{ borderRadius: "5px !important" }}
                              onClick={() => {
                                setOpenAddSubReportModal(false);

                                setPermissionGroupsValue(undefined);
                                setPermissionTypeValue(undefined);
                              }}
                            >
                              انصراف
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default AddEditSubPermissionModal;
